import { LOADING, SUCCEEDED, ERROR } from '@constants/fetchStatuses'
import { getToken } from '@auth/token-service'
import processError from '../helpers/processError'
import 'isomorphic-fetch'

/* global SERVER_BASE_URL */

export const FETCH_APPRAISER_SPECIALIZATIONS_REQUEST = 'FETCH_APPRAISER_SPECIALIZATIONS_REQUEST'
export const FETCH_APPRAISER_SPECIALIZATIONS_SUCCESS = 'FETCH_APPRAISER_SPECIALIZATIONS_SUCCESS'
export const FETCH_APPRAISER_SPECIALIZATIONS_FAILURE = 'FETCH_APPRAISER_SPECIALIZATIONS_FAILURE'
export const SAVE_APPRAISER_SPECIALIZATIONS_REQUEST = 'SAVE_APPRAISER_SPECIALIZATIONS_REQUEST'
export const SAVE_APPRAISER_SPECIALIZATIONS_SUCCESS = 'SAVE_APPRAISER_SPECIALIZATIONS_SUCCESS'
export const SAVE_APPRAISER_SPECIALIZATIONS_FAILURE = 'SAVE_APPRAISER_SPECIALIZATIONS_FAILURE'

const fetchRequest = () => ({ type: FETCH_APPRAISER_SPECIALIZATIONS_REQUEST, status: LOADING })
const fetchSuccess = (data) => ({ type: FETCH_APPRAISER_SPECIALIZATIONS_SUCCESS, data, status: SUCCEEDED })
const fetchFailure = (errorMessage) => ({ type: FETCH_APPRAISER_SPECIALIZATIONS_FAILURE, errorMessage, status: ERROR })

const saveRequest = () => ({ type: SAVE_APPRAISER_SPECIALIZATIONS_REQUEST, status: LOADING })
const saveSuccess = (data) => ({ type: SAVE_APPRAISER_SPECIALIZATIONS_SUCCESS, data, status: SUCCEEDED })
const saveFailure = (errorMessage) => ({ type: SAVE_APPRAISER_SPECIALIZATIONS_FAILURE, errorMessage, status: ERROR })

const buildHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  'content-type': 'application/json',
  accept: 'application/json',
})

export function fetchAppraiserSpecializations() {
  return (dispatch) => {
    dispatch(fetchRequest())
    return fetch(`${SERVER_BASE_URL}/api/appraiser-specializations`, {
      method: 'GET',
      headers: buildHeaders(),
    })
      .then((response) => response.json().then((result) => ({ result, response })))
      .then(({ result, response }) => {
        if (!response.ok) {
          dispatch(fetchFailure(processError(result)))
          return Promise.reject(result)
        }
        dispatch(fetchSuccess(result))
        return result
      })
  }
}

export function saveAppraiserSpecializations(payload) {
  return (dispatch) => {
    dispatch(saveRequest())
    return fetch(`${SERVER_BASE_URL}/api/appraiser-specializations`, {
      method: 'PUT',
      headers: buildHeaders(),
      body: JSON.stringify(payload),
    })
      .then((response) => response.json().then((result) => ({ result, response })))
      .then(({ result, response }) => {
        if (!response.ok) {
          dispatch(saveFailure(processError(result)))
          return Promise.reject(result)
        }
        dispatch(saveSuccess(result))
        return result
      })
  }
}
